import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { RequestsFormValues } from '../../models';
import { Colors } from '../../../../../assets';
import { Spacing } from '../../../../../assets/GlobalStyle/Variables';
import { FieldError } from './FieldError';

export const RTGForm: FC = () => {
  const { register, formState: { errors } } = useFormContext<RequestsFormValues>();

  return (
    <Wrapper>
      <Label>Požadované vyšetření</Label>
      <Textarea
        {...register('rtg.request_text', {
          maxLength: { value: 500, message: 'Max 500 znaků' },
          required: 'Požadované vyšetření je povinné'
        })}
      />
      <FieldError error={(errors as any)?.rtg?.request_text} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(2)};
`;

const Label = styled.div`
  color: ${Colors.grey};
  font-weight: 700;
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 180px;
  border: 1px solid ${Colors.lightGrey};
  padding: ${Spacing(2)};
  resize: vertical;
`;
